<template>
    <div class="container pt-3">
        <div class="row justify-content-lg-center">
            <div class="col-lg-12" style="font-size: 0.8rem">
                <div class="d-flex justify-content-between align-items-center" style="height: 37.79px; margin-bottom: 20px">
                    <div class="d-flex align-items-baseline" style="gap: 10px">
                        <h1 class="h1-title" style="font-weight: 500 !important; line-height: 21px">{{ $t('views.products.title') }}</h1>
                        <span
                            v-if="currentMarket.sync_state && syncStates.findIndex((state) => state === 'HISTORICAL_ORDERS_SYNC_COMPLETED') > syncStates.findIndex((state) => state === currentMarket.sync_state) && currentMarket.status === 1"
                            class="text-muted"
                            >{{ $t('views.orders.loadingText') }} <img src="@/assets/extension-loader.gif" height="24" />
                        </span>
                    </div>
                    <div class="d-flex align-items-center">
                        <span v-if="list.lastUpdate" style="font-style: italic; color: #677788; margin-right: 10px">
                            {{ $t('views.orders.last_update') }} <strong>{{ formatDate(list.lastUpdate) }}</strong>
                        </span>
                        <DateRangePicker :callback="handleDate" :singleDatePicker="false" :dateData="date_range" openPosition="left" :language="$i18n.locale" />
                    </div>
                </div>
                <div class="store-tabs">
                    <router-link :to="{ name: 'orders' }" class="store-tabs__item">
                        <span>{{ $t('views.orders.title') }}</span>
                        <span class="count-badge">{{ totalOrders }}</span>
                    </router-link>
                    <router-link :to="{ name: 'orders-products' }" class="store-tabs__item active">
                        <span>{{ $t('views.products.title') }}</span>
                        <span class="count-badge">{{ list.total }}</span>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="action-header">
            <div class="d-flex justify-content-between align-items-center sm-flex-column">
                <div class="d-flex sm-flex-column">
                    <div class="d-flex">
                        <div class="d-flex flex-column justify-content-center" style="border-right: 0.6px solid #e7eaf3; margin-right: 8px; padding-right: 15px; color: #677788">
                            <strong>{{ list.total }}</strong>
                            <span>{{ $t('views.products.result') }}</span>
                        </div>
                        <div class="mr-8">
                            <select :value="filterParams.perPage" class="form-select form-select-sm" @change="SET_FILTER_PARAMS({ key: 'perPage', value: +$event.target.value })">
                                <option v-for="i in [10, 25, 50, 100]" :key="i" :value="i">{{ i }} {{ $t('views.products.perPage') }}</option>
                            </select>
                        </div>
                        <div class="mr-8">
                            <select :value="filterParams.page" class="form-select form-select-sm" @change="handlePage($event.target.value)">
                                <option v-for="n in totalPages" :key="n" :value="n" :selected="n === filterParams.page">{{ n }}. {{ $t('views.products.page') }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="search-form">
                        <input
                            :value="filterParams.search"
                            class="form-control form-control-sm"
                            type="text"
                            :placeholder="$t('views.products.search')"
                            style="font-size: 13px; height: 37.5px"
                            @change="SET_FILTER_PARAMS({ key: 'search', value: $event.target.value.trim() })"
                            @keyup.enter="getProducts"
                        /><button class="btn btn-sm btn-link" style="height: 37.5px; line-height: 1; position: absolute; top: -2px; right: 0" @click="getProducts">
                            <i class="fa-solid fa-magnifying-glass"></i>
                        </button>
                    </div>
                </div>
                <div class="d-flex">
                    <button class="btn btn-sm" :class="isFilterComponentVisible ? 'btn-primary' : 'bg-white'" style="margin-right: 8px; border: 0.6px solid #e7eaf3" @click="isFilterComponentVisible = !isFilterComponentVisible">
                        <i class="fa fa-filter" style="font-size: 18px"></i>
                    </button>
                    <button class="dropdown btn bg-white btn-sm" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside" style="border: 0.6px solid #e7eaf3">
                        <i class="fa fa-gear" style="font-size: 18px"></i>
                    </button>
                    <div class="dropdown-menu dropdown-menu-end navbar-dropdown-menu navbar-dropdown-menu-borderless navbar-dropdown-account" aria-labelledby="accountNavbarDropdown" data-popper-placement="top-end" style="width: 240px; padding: 0">
                        <label v-for="(column, index) in getColumns" :key="column.key" class="d-flex align-items-center" style="gap: 10px; height: 37px; padding-left: 10px; border-bottom: 0.6px solid #e7eaf3; color: #677788">
                            <input type="checkbox" class="form-check-input mt-0" :checked="column.visible" @change="setLocalStorageColumns(index)" />
                            {{ $t(`views.products.columns.${column.key}`) }}
                        </label>
                    </div>
                    <!-- <button class="btn btn-primary btn-sm" style="border: 0.6px solid #e7eaf3">
                    {{ $t('views.products.placeOrder') }}
                </button> -->
                </div>
            </div>
        </div>
    </div>
    <InventoryFilters v-model="isFilterComponentVisible" @handleApply="handleApply" />
    <ProductsTableList v-model="hasColumnVisible" :type="'order'" />
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import ProductsTableList from '@/components/Orders/ProductsTableList.vue'
import InventoryFilters from '@/components/Inventory/InventoryFilters.vue'
import DateRangePicker from '@/components/DateRangePicker.vue'
import '@vuepic/vue-datepicker/dist/main.css'
import moment from 'moment'

export default {
    name: 'OrdersProducts',
    components: { ProductsTableList, DateRangePicker, InventoryFilters },
    data: function () {
        return {
            date_range: {
                startDate: moment().subtract(1, 'years').format('YYYY-MM-DD'),
                endDate: moment().format('YYYY-MM-DD'),
            },
            isFilterComponentVisible: false,
            totalOrders: 0,
            syncStates: [
                'INITIAL',
                'INVENTORY_SYNC_STARTED',
                'INVENTORY_SYNC_COMPLETED',
                'FEE_REPORT_COMPLETED',
                'RECENT_ORDERS_SYNC_STARTED',
                'RECENT_ORDERS_SYNC_COMPLETED',
                'HISTORICAL_ORDERS_SYNC_STARTED',
                'HISTORICAL_ORDERS_SYNC_COMPLETED',
                'SYNC_COMPLETED',
            ],
        }
    },
    computed: {
        ...mapState('products', ['columns', 'filterParams', 'list', 'selectedRows']),
        ...mapState('inventory', ['isApplyFiltering', 'selectedFilterCard', 'filterOptions']),
        ...mapGetters({
            currentMarket: 'market/currentMarket',
            totalPages: 'products/totalPages',
        }),
        hasColumnVisible() {
            return this.columns.some((column) => column.visible)
        },
        getColumns() {
            return this.columns
        },
    },
    mounted() {
        if (this.$route.name.match('orders')) {
            document.querySelector('body').classList.add('bg-white')
        }
    },
    unmounted() {
        document.querySelector('body').classList.remove('bg-white')
    },
    created() {
        const startDate = new Date()
        const endDate = new Date(new Date().setDate(startDate.getDate() + 7))
        this.date = [startDate, endDate]
        const columns = localStorage.getItem('columns.products')

        if (columns) {
            this.SET_COLUMNS(JSON.parse(columns))
        }
        this.getProducts()
        this.getOrders().then(({ data }) => {
            this.totalOrders = data.total
        })
    },
    methods: {
        ...mapActions({
            getOrders: 'orders/getOrders',
            getProducts: 'products/getProducts',
            applyFilter: 'inventory/applyFilter',
        }),
        ...mapMutations('products', ['SET_COLUMN_TOGGLE', 'SET_FILTER_PARAMS', 'SET_COLUMNS', 'SET_LIST']),
        getImage(src) {
            return require('@/assets/svg-flag/' + src + '.svg')
        },
        handleApply(data) {
            this.SET_LIST(data)
        },
        handleDate(data) {
            if (this.date_range.startDate != moment(data.startDate).format('YYYY-MM-DD') || this.date_range.endDate != moment(data.endDate).format('YYYY-MM-DD')) {
                this.date_range = {}
                this.date_range.startDate = moment(data.startDate).format('YYYY-MM-DD')
                this.date_range.endDate = moment(data.endDate).format('YYYY-MM-DD')
                this.SET_FILTER_PARAMS({ key: 'dateRange', value: `${this.date_range.startDate},${this.date_range.endDate}` })
            }
        },
        setLocalStorageColumns(index) {
            this.SET_COLUMN_TOGGLE(index)
            localStorage.setItem('columns.products', JSON.stringify(this.columns))
        },
        formatDate(date) {
            return moment(date).format('HH:mm')
        },
        handlePage(page) {
            this.SET_FILTER_PARAMS({ key: 'page', value: +page })
            const { search, filter_id, sortBy, ...filterParams } = this.filterParams
            if (this.isApplyFiltering && !filter_id) {
                this.applyFilter({ payload: { filter_id: this.selectedFilterCard.id, options: this.filterOptions }, params: filterParams })
            } else {
                this.getProducts()
            }
        },
    },
    watch: {
        'filterParams.perPage': function () {
            this.handlePage(1)
        },
        'filterParams.search': function () {
            this.SET_FILTER_PARAMS({ key: 'page', value: 1 })
            this.getProducts()
        },
        'filterParams.dateRange': function () {
            this.SET_FILTER_PARAMS({ key: 'page', value: 1 })
            this.getProducts()
        },
    },
}
</script>

<style lang="scss">
:root {
    --redesign-gray: #f8fafd;
    --redesign-primary: #ffb53e;
}
.dp__theme_light {
    --dp-primary-color: #ffb53e;
}
.store-tabs {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-bottom: 5px;

    &__item {
        height: 53px;
        padding: 16px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        gap: 5px;
        font-size: 14px;
        font-weight: 500;
        line-height: 21px;
        color: #132144;
        cursor: pointer;

        &:hover {
            background-color: #bdc5d133;
            color: #132144;
        }

        &.active {
            background-color: #bdc5d133;
            color: #132144;
        }

        .count-badge {
            padding: 3.67px 5.86px 3.67px 6.81px;
            border-radius: 800px;
            background-color: #677788;
            color: #fff;
            font-size: 10.5px;
            font-weight: 700;
            line-height: 12.71px;
            text-align: center;
        }
    }
}
body.is-sticky {
    .action-header {
        position: fixed;
        top: 30px;
        z-index: 5;
        width: calc(100% - 50px);

        > div {
            border-top: 1px solid #e7eaf3b2;
            margin-top: 0;
            margin-bottom: 0;
        }
    }

    .custom-table-items {
        thead {
            box-shadow: 0px 60px 50px 0px #00203f40;
        }
    }
}
.action-header {
    & > div {
        display: block;
        background-color: var(--inventory-gray);
        margin-top: 10px;
        margin-bottom: 15px;
        font-size: 14px;
        font-weight: 400;
        line-height: 16.94px;
        padding-left: 12px;
        padding-right: 12px;
        height: 69.79px;
    }
    &__btn {
        display: flex;
        align-items: center;
        width: 100%;
        gap: 10px;
        height: 37px;
        padding-left: 10px;
        border-bottom: 0.6px solid #e7eaf3 !important;
        color: #677788 !important;
    }
}

.dp__input_wrap {
    width: auto;
    > input {
        padding-inline-end: 12px !important;
        font-size: 14px;
        border: 0.6px solid #e7eaf3;
        color: #677788;
        width: 220px !important;
    }
}
</style>
